import "../vendor/slider.min.js";
import FuiModuleModifier from "./fui-module";

export default class FuiSliderModifier extends FuiModuleModifier {
  override semanticModuleName = "slider";

  override settingExistsOnModule(setting: string): boolean {
    if (setting === "interpretLabel") return true;

    return super.settingExistsOnModule(setting);
  }
}
